import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CategoriaPermissaoListarRoutingModule } from './categoria-permissao-listar-routing.module';
import { CategoriaPermissaoListarComponent } from './categoria-permissao-listar.component';


@NgModule({
  declarations: [
    CategoriaPermissaoListarComponent
  ],
  imports: [
    CommonModule,
    CategoriaPermissaoListarRoutingModule
  ]
})
export class CategoriaPermissaoListarModule { }
